/**
 * Video Category event handlers
 */
import { fetchVideoCategories } from './ajax.js';
import { displayVideoCategories, renderLoading } from './render.js';

let searchTimeout = null;

/**
 * Handle initial data load
 * @param {HTMLElement} container - Results container
 */
export async function handleInitialLoad(container) {
	if (!container) return;

	renderLoading(container);

	try {
		const data = await fetchVideoCategories();
		await displayVideoCategories(container, data.categories);
	} catch (error) {
		console.error('Error in handleInitialLoad:', error);
	}
}

/**
 * Handle search input with debounce
 * @param {Event} e - Input event
 * @param {HTMLElement} container - Results container
 */
export function handleSearch(e, container) {
	const value = e.target.value.trim();

	if (searchTimeout) clearTimeout(searchTimeout);

	searchTimeout = setTimeout(async () => {
		if (!container) return;

		renderLoading(container);

		try {
			const data = await fetchVideoCategories(value);
			await displayVideoCategories(container, data.categories);
		} catch (error) {
			console.error('Error in handleSearch:', error);
		}
	}, 500);
}
